<template>
  <v-list subheader two-line>
    <!-- Institutional -->
    <v-list-tile
      avatar
      v-if="notice.institutional == true"
    >
      <v-list-tile-avatar>
        <v-icon color="primary" large>account_balance</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>Comunicado</v-list-tile-title>
        <v-list-tile-sub-title>institucional</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Institutional -->

    <!-- Level -->
    <v-subheader 
      v-if="notice.levels.length > 0"
      class="tittlesDetails"
      style="padding: 0px; margin: 0px">
      Niveles:</v-subheader>
    <v-slide-y-transition class="two-line subheader" group v-if="notice.levels.length > 0">
      <v-list-tile
        avatar
        class="pa-0 mb-3 list-group-item item"
        style="border-radius: 5px;"
        v-for="element in notice.levels"
        :key="element.id"
      >
        <v-list-tile-avatar>
          <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="element.typeLevel"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-slide-y-transition>
    <!-- Level -->

    <!-- Groups -->
    <v-subheader 
      v-if="notice.groups.length > 0"
      class="tittlesDetails"
      style="padding: 0px; margin: 0px">
      Grupos:</v-subheader>
    <v-slide-y-transition class="two-line subheader" v-if="notice.groups.length > 0" group>
      <v-list-tile
        avatar
        class="pa-0 mb-3 ml-2 list-group-item item"
        style="border-radius: 5px;"
        v-for="element in notice.groups"
        :key="element.id"
      >
        <v-list-tile-avatar>
          <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="element.grade + ' ' + element.group"></v-list-tile-title>
          <v-list-tile-sub-title v-text="element.level.typeLevel"></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-slide-y-transition>
    <!-- Groups -->

    <!-- Students -->
    <v-subheader
      v-if="studentsFromNotice.length > 0"
      key="subheader"
      class="tittlesDetails"
      style="padding: 0px; margin: 0px">
      Alumnos:</v-subheader>
    <v-list two-line subheader>
      <RecycleScroller
        v-if="studentsFromNotice.length > 0"
        :items="studentsFromNotice"
        :item-size="60"
      >
        <template v-slot="{ item }">
          <v-list-tile
            avatar
            class="pa-0 mb-3 ml-2 list-group-item item"
            style="border-radius: 5px;"
          >
            <v-list-tile-avatar>
              <v-img :src="require('@/assets/panel/home/SKLB-Alumnos.png')"></v-img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.firstName + ' ' + item.lastName"></v-list-tile-title>
              <v-list-tile-sub-title>{{ item.level.typeLevel + ' ' + item.gg.grade + ' ' + item.gg.group }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </RecycleScroller>
    </v-list>
    <!-- Students -->

    <!-- SubGroups -->
    <v-subheader 
      v-if="notice.subgroups.length > 0"
      class="tittlesDetails"
      style="padding: 0px; margin: 0px">
      Subgrupos:</v-subheader>
    <v-slide-y-transition class="two-line subheader" v-if="notice.subgroups.length > 0" group>
      <v-list-tile
        avatar
        class="pa-0 mb-3 ml-2 list-group-item item"
        style="border-radius: 5px;"
        v-for="element in notice.subgroups"
        :key="element.id"
      >
        <v-list-tile-avatar>
            <v-img :src="require('@/assets/panel/home/SKLB-Grupos.png')"></v-img>
        </v-list-tile-avatar>
        <v-list-tile-content>
            <v-list-tile-title v-text="element.name"></v-list-tile-title>
            <!-- <v-list-tile-title v-text="element.level.typeLevel"></v-list-tile-title> -->
        </v-list-tile-content>
      </v-list-tile>
    </v-slide-y-transition>
    <!-- SubGroups -->

    <!-- Colaboradores -->
    <v-subheader v-if="notice.employeeAudience.length > 0">Colaboradores</v-subheader>
    <v-slide-y-transition class="two-line subheader" v-if="notice.employeeAudience.length > 0" group>
      <v-list-tile
        avatar
        class="pa-0 mb-3 ml-2 list-group-item item"
        style="border-radius: 5px;"
        v-for="element in notice.employeeAudience"
        :key="element.id"
      >
        <v-list-tile-avatar>
          <v-img :src="require('@/assets/panel/home/SKLB-Colabordores.png')"></v-img>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="element.name"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-slide-y-transition>
    <!-- Colaboradores -->
  </v-list>
</template>

<script>
export default {
  props: ["notice"],
  computed: {
    studentsFromNotice() {
      let stds = this.notice.students.filter(student => {
        for (let lvl of this.notice.levels) {
          if (lvl.id == student.level.id) {
            return false;
          }
        }
        for (let gg of this.notice.groups) {
          if (gg.id == student.gg.id) {
            return false;
          }
        }
        return true;
      });

      console.log(stds);
      return stds;
    }
  }
};
</script>

<style scoped>
.tittlesDetails{
  font-size: 1.4rem;
  font-weight: bold;
  color: black;
}

</style>